/*
 * Barra de proporção — orçamento do provider, consumo de plano, progresso.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ A LARGURA VAI POR CLASSE — MAS NÃO PELO MOTIVO QUE A PRIMEIRA VERSÃO    │
 * │ DESTE ARQUIVO ALEGAVA.                                                   │
 * │                                                                          │
 * │ Ela dizia que `style={{ width }}` quebraria sob a CSP servida pelo       │
 * │ nginx (`style-src 'self'`, sem `unsafe-inline`). **Isso estava errado**  │
 * │ — a correção está em D-260.                                              │
 * │                                                                          │
 * │ A CSP alcança `<style>` e atributos `style="..."` no HTML servido. Ela   │
 * │ NÃO alcança o CSSOM, e é por CSSOM que o React aplica `style={{}}`       │
 * │ (`node.style.width = ...`). A evidência está no próprio bundle: os       │
 * │ primitivos Radix usam `style` inline para posicionar diálogo e popover,  │
 * │ e o painel funciona sob esta CSP.                                        │
 * │                                                                          │
 * │ O componente fica por duas razões que sobrevivem à correção:             │
 * │                                                                          │
 * │ - carrega `role="progressbar"` com `aria-valuenow/min/max`. Uma `div`    │
 * │   colorida não diz nada a leitor de tela, e o piso do doc 06a §7 é que   │
 * │   nenhuma informação seja transmitida só por elemento visual;            │
 * │ - `total` zero não é 0% nem 100%: é "não há teto medido". A divisão      │
 * │   daria `NaN`, e `NaN` numa largura some sem avisar.                     │
 * │                                                                          │
 * │ Vinte e um passos de 5% dão resolução de sobra para uma barra fina, e as │
 * │ classes ficam literais no arquivo para o Tailwind as gerar.              │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
const LARGURAS = [
  "w-0",
  "w-[5%]",
  "w-[10%]",
  "w-[15%]",
  "w-[20%]",
  "w-[25%]",
  "w-[30%]",
  "w-[35%]",
  "w-[40%]",
  "w-[45%]",
  "w-[50%]",
  "w-[55%]",
  "w-[60%]",
  "w-[65%]",
  "w-[70%]",
  "w-[75%]",
  "w-[80%]",
  "w-[85%]",
  "w-[90%]",
  "w-[95%]",
  "w-full",
] as const;

export function Barra({
  usado,
  total,
  rotulo,
  /** Acima desta proporção a barra vira vermelha. */
  alertaAcimaDe = 0.8,
}: {
  usado: number;
  total: number;
  /** Descrição acessível — a barra sozinha não diz nada a leitor de tela. */
  rotulo: string;
  alertaAcimaDe?: number;
}) {
  // Total zero não é 0% nem 100%: é "não há teto medido". Dividir por ele daria
  // `NaN`, e `NaN` numa classe some sem avisar.
  const proporcao = total > 0 ? Math.min(Math.max(usado / total, 0), 1) : 0;
  const passo = Math.round(proporcao * 20);
  const largura = LARGURAS[passo] ?? "w-0";

  return (
    <div
      role="progressbar"
      aria-label={rotulo}
      aria-valuenow={usado}
      aria-valuemin={0}
      aria-valuemax={total}
      className="h-1.5 overflow-hidden rounded-full bg-superficie-2"
    >
      <div
        className={`h-full ${largura} ${
          proporcao > alertaAcimaDe ? "bg-falha" : "bg-confirmado"
        }`}
      />
    </div>
  );
}
